import { h } from "omi";

import { IconProps } from "@/components";

export function LogoMarkLightIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 12 13">
      <g fill="#F8F5F1" clip-path="url(#a)">
        <path d="M6.20812 1.93016c1.46913 1.38876 3.0842 2.63489 4.80048 3.70378l.9912.61738C11.8693 3.05294 9.23338.5 6.00061.5c-.40474 0-.80002.040139-1.18225.11639l1.38991 1.31377h-.00015ZM5.92221 2.23259 4.33633.733398C3.41386.998817 2.5827 1.47938 1.90039 2.11703c2.73699 1.75626 5.72042 3.05392 8.87051 3.85906-1.73322-1.08112-3.36441-2.34058-4.84869-3.74365v.00015Z" />
        <path d="M10.3289 6.29219c-3.07918-.82418-5.99754-2.11488-8.68158-3.84102l-.04851-.03125C.64839 3.44313.05101 4.79841 0 6.29219h10.3289ZM1.70096 10.5149c2.67195-1.70965 5.57587-2.98897 8.63784-3.80689H0c.05101 1.49376.648389 2.84892 1.59867 3.87229l.10215-.0654h.00014ZM10.9435 7.41084C9.27036 8.45919 7.69323 9.67698 6.25579 11.0303l-1.43743 1.3534c.38208.0762.77737.1162 1.18183.1162 3.23264 0 5.86841-2.55264 5.99921-5.75088l-1.056.66168.0001.00014Z" />
        <path d="M5.96989 10.7275C7.42691 9.35555 9.02587 8.12096 10.722 7.05817l.0522-.03278c-3.14116.80181-6.11791 2.09364-8.84893 3.84101l-.02586.0165c.68217.6377 1.51334 1.1182 2.43581 1.3837l1.63467-1.5392v.0001Z" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h12v12H0z" transform="translate(0 .5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
